import type { Prng } from './prng';

export type MontyStrategy = 'switch' | 'stay' | 'random';

export function montyHallRound(strategy: MontyStrategy, prng: Prng): { win: boolean } {
  const prize = prng.int(3);
  const pick = prng.int(3);
  const remaining = [0, 1, 2].filter((d) => d !== prize && d !== pick);
  const hostReveal = remaining.length === 2 ? remaining[prng.int(2)]! : remaining[0]!;
  const switchTarget = [0, 1, 2].find((d) => d !== pick && d !== hostReveal)!;
  let finalChoice: number;
  switch (strategy) {
    case 'switch':
      finalChoice = switchTarget;
      break;
    case 'stay':
      finalChoice = pick;
      break;
    case 'random':
      finalChoice = prng.next() < 0.5 ? pick : switchTarget;
      break;
  }
  return { win: finalChoice === prize };
}

export function birthdayHasMatch(n: number, prng: Prng): boolean {
  if (n < 2) return false;
  const seen = new Set<number>();
  for (let i = 0; i < n; i++) {
    const day = prng.int(365);
    if (seen.has(day)) return true;
    seen.add(day);
  }
  return false;
}

/** 1 − 365! / (365ⁿ · (365 − n)!), via the iterative non-collision form for stability. */
export function theoreticalBirthdayProb(n: number): number {
  if (n < 2) return 0;
  if (n > 365) return 1;
  let noMatch = 1;
  for (let i = 0; i < n; i++) noMatch *= (365 - i) / 365;
  return 1 - noMatch;
}

export function buffonNeedleHit(needleLen: number, lineSpacing: number, prng: Prng): boolean {
  const y = prng.next() * (lineSpacing / 2);
  const theta = prng.next() * (Math.PI / 2);
  return y <= (needleLen / 2) * Math.sin(theta);
}
